import { shape, string } from 'prop-types';

export default shape({
    main_price: string.isRequired,
    secondary_price: string,
});
